import FetchClient from "./FetchClient";

interface MaintenanceStatus {
  underMaintenance: boolean;
}

export class MaintenanceService {
  static async checkMaintenance(): Promise<boolean> {
    try {
      const response = await FetchClient.get<MaintenanceStatus>(
        "/maintenance",
        {},
        true
      );
      return response.underMaintenance;
    } catch (error) {
      console.error("Failed to check maintenance status:", error);
      return false; // Default to not in maintenance if endpoint fails
    }
  }
}
